import {
  SHIPPING_TYPE,
  PAYMENT_STATUS,
  REVIEW_LANGUAGE_TYPE,
  SHIPPING_LABEL_OPTION,
  APPROVED_STATUS,
} from './../shared/common-code.type';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Injector } from './injector/injector';
import { FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { PartialObserver } from 'rxjs';
import { ErrorResponse, ERROR_TYPE, FieldError } from './errors';
import $ from 'jquery';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog } from '@angular/material/dialog';
import {
  PRODUCT_STATUS,
  INQUIRY_TYPE,
  PRODUCT_TYPE,
  PAYMENT_METHOD,
  REFUND_METHOD,
  PURCHASE_ORDER_ADMIN_STATUS,
  INCOTERMS,
  SHIPPING_SERVICE_CODE,
  PURCHASE_ORDER_PARTIAL_REFUND_STATUS,
  FAQ_CATEGORY,
  FAQ_TYPE,
  MSDS_POSSESSION_STATUS,
  WITHDRAW_TYPE,
  REFUND_TYPE,
  LANGUAGE_TYPE,
  DISCOUNT_TYPE,
} from '../shared/common-code.type';
import { CustomDialogComponent } from '../modules/resp/_component/custom-dialog/custom-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { Injectable, OnDestroy } from '@angular/core';
import dayjs from 'dayjs';

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warn',
}
export interface DialogData {
  title?: string;
  message: string;
  subMessage?: string;
  cancel?: () => void;
  close?: (data: any) => void;
}
@Injectable({
  providedIn: 'root',
})
export class BaseComponent implements OnDestroy {
  LANGUAGE_TYPE = LANGUAGE_TYPE;
  FAQ_TYPE = FAQ_TYPE;
  FAQ_CATEGORY = FAQ_CATEGORY;
  INCOTERMS = INCOTERMS;
  SHIPPING_SERVICE_CODE = SHIPPING_SERVICE_CODE;
  PRODUCT_STATUS = PRODUCT_STATUS;
  PRODUCT_TYPE = PRODUCT_TYPE;
  INQUIRY_TYPE = INQUIRY_TYPE;
  PAYMENT_METHOD = PAYMENT_METHOD;
  REFUND_TYPE = REFUND_TYPE;
  REFUND_METHOD = REFUND_METHOD;
  WITHDRAW_TYPE = WITHDRAW_TYPE;
  PURCHASE_ORDER_PARTIAL_REFUND_STATUS = PURCHASE_ORDER_PARTIAL_REFUND_STATUS;
  PURCHASE_ORDER_ADMIN_STATUS = PURCHASE_ORDER_ADMIN_STATUS;
  MSDS_POSSESSION_STATUS = MSDS_POSSESSION_STATUS;
  DISCOUNT_TYPE = DISCOUNT_TYPE;
  SHIPPING_TYPE = SHIPPING_TYPE;
  PAYMENT_STATUS = PAYMENT_STATUS;
  SHIPPING_LABEL_OPTION = SHIPPING_LABEL_OPTION;
  APPROVED_STATUS = APPROVED_STATUS;

  isAlive = true;

  HOME_URL = '/home';
  // HOME_URL = '/my';
  baseRouter: Router;
  i18n: ITranslationService;
  location: Location;
  clipBoard: ClipboardService;
  dialog: MatDialog;
  deviceDetector: DeviceDetectorService;
  store: Store<any>;

  userDeviceInfo = 'pc';
  today = dayjs().toDate();
  LANGUAGES = Object.freeze([
    { locale: LANGUAGE_TYPE.EN, label: 'LANGUAGE.EN' },
    // { locale: LANGUAGE_TYPE.VI, label: 'LANGUAGE.VI' },
  ]);

  REVIEW_LANGUAGES = Object.freeze([
    { locale: REVIEW_LANGUAGE_TYPE.EN, label: 'English' },
    { locale: REVIEW_LANGUAGE_TYPE.VI, label: 'Vietnamese' },
    { locale: REVIEW_LANGUAGE_TYPE.RU, label: 'Russian' },
    { locale: REVIEW_LANGUAGE_TYPE.DE, label: 'German' },
    { locale: REVIEW_LANGUAGE_TYPE.FR, label: 'French' },
    { locale: REVIEW_LANGUAGE_TYPE.PT, label: 'Portuguese' },
    { locale: REVIEW_LANGUAGE_TYPE.ES, label: 'Spanish' },
    { locale: REVIEW_LANGUAGE_TYPE.IT, label: 'Italian' },
    { locale: REVIEW_LANGUAGE_TYPE.AR, label: 'Arabic' },
    { locale: REVIEW_LANGUAGE_TYPE.NL, label: 'Dutch' },
    { locale: REVIEW_LANGUAGE_TYPE.SV, label: 'Swedish' },
    { locale: REVIEW_LANGUAGE_TYPE.JA, label: 'Japanese' },
  ]);

  // 간편 인증 주기적 변경 코드
  simpleInfo = {
    company: 'Cosmoprof India Mumbai 2024',
    city: 'Mumbai',
    manager: ['Rina', 'Hyelin Yang', 'Taeyoon Barn', 'None'],
  };

  constructor() {
    this.baseRouter = Injector.get(Router);
    this.i18n = Injector.get(I18NEXT_SERVICE);
    this.location = Injector.get(Location);
    this.clipBoard = Injector.get(ClipboardService);
    this.dialog = Injector.get(MatDialog);
    this.deviceDetector = Injector.get(DeviceDetectorService);
    this.store = Injector.get(Store);

    this.userDeviceInfo = this.deviceDetector.isDesktop() ? 'pc' : 'mobile';

    // @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService
    // this.location = Injector.get(Location);
    // this.activatedRoute = injector.get(ActivatedRoute);
    // this.confirmationService = Injector.get(ConfirmationService);
    // this.messageService = Injector.get(MessageService);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
  }

  public errors: any = {};

  public goHome() {
    this.baseRouter.navigateByUrl(this.HOME_URL);
  }

  public goWaiting() {
    this.baseRouter.navigateByUrl('/signin/waiting');
  }

  // go to Main
  public goMain() {
    // return;
    this.baseRouter.navigateByUrl('/');
    this.location.go('#');
    document.location.href = '/';
    // if (this.i18n.language === this.LANGUAGES[1].locale) {
    //   window.location.assign('/vi');
    // } else {
    //   window.location.assign('#');
    // }
  }

  public go404() {
    this.baseRouter.navigateByUrl('/not-found');
  }

  // go to url in main Page
  public goMainUrl(location: string) {
    // return;
    const language = this.i18n.language === LANGUAGE_TYPE.EN ? '' : '/vi';
    window.location.assign(`${language}/about/${location}`);
  }

  public goBrand(brandId: number) {
    this.baseRouter.navigate([`/brand`, brandId], { queryParams: { brandId } });
  }

  public goBack() {
    this.location.back();
  }

  // private activatedRoute: ActivatedRoute;
  // private confirmationService: ConfirmationService;
  // private messageService: MessageService;

  // protected router: Router;
  // protected location: Location;

  // protected queryParams(callback: (params: any) => void, initExecute = true): void {
  //   if (initExecute === undefined || initExecute === true) {
  //     const queryParameterTmp = this.router.url.split('?')[1];
  //     const queryParameter = queryParameterTmp ? queryParameterTmp.split('#')[0] : null;
  //     callback(parse(queryParameter, { parseNumbers: true }));
  //   }

  //   this.location.onUrlChange((url: string, state: any) => {
  //     const queryParameterTmp = url.split('?')[1];
  //     const queryParameter = queryParameterTmp ? queryParameterTmp.split('#')[0] : null;
  //     callback(parse(queryParameter, { parseNumbers: true }));
  //   });
  // }

  // protected changeUrl(...params: any) {
  //   let queryParams = {};
  //   params.forEach(param => {
  //     queryParams = { ...queryParams, ...param };
  //   });
  //   const url = this.router.url.split('?')[0].split('#')[0];
  //   this.location.go(url, stringify(queryParams));
  // }

  /*
  protected confirm(title: string, message: string, accept: Function, reject?: Function): void {
    this.confirmationService.confirm({
      header: title,
      message: message,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: '예',
      rejectLabel: '아니오',
      rejectVisible: true,
      accept: () => {
        accept();
      },
      reject: () => {
        if (reject) {
          reject();
        }
      }
    });
  }
  */

  /**
   * @praram data:DialogData
   */
  protected _openDialog(data: DialogData) {
    const config = {
      height: 'auto',
      panelClass: [this.userDeviceInfo, 'dialog'],
      data,
    };
    const dialog = this.dialog.open(CustomDialogComponent, config);
    return dialog;
  }
  /*
  protected toast(type: ToastType, summary: string, detail?: string) {
    this.messageService.add({ severity: type, life: 3000, summary: summary, detail: detail });
  }
  */

  /*
  protected withResponseValidator<T>(
    form: FormGroup,
    next: (value: T) => void,
    err?: (error: any) => void
  ): PartialObserver<T> {
    return {
      next,
      error: (error: any) => {
        if (
          error.error &&
          error.error.statusCode === 400 &&
          error.error.error === 'Bad Fields Request'
        ) {
          // console.log(error.error);
          Object.keys(error.error.message).forEach(field => {
            const control = form.controls[field];
            if (control) {
              const value = error.error.message[field];
              Object.keys(value).forEach(validationName => {
                // 2depth recursive 에러 처리
                if (typeof value[validationName] === 'object') {
                  Object.keys(value[validationName]).forEach(
                    subValidationName => {
                      control.setErrors({ [subValidationName]: true });
                    }
                  );
                  return;
                }
                // 1depth 에러 처리
                control.setErrors({ [validationName]: true });
              });
            }
          });
          if (err) {
            err(error);
          }
          return;
          // return true;
        }
      },
    };
  }
  */

  ngOnDestroy() {
    this.isAlive = false;
  }

  onChangeLanguage(language: string) {
    if (language !== this.i18n.language) {
      this.store.dispatch(new IndicatorStore.ShowIndicator('onChangeLanguage'));
      this.i18n.changeLanguage(language).then((x) => {
        document.location.reload();
        this.store.dispatch(new IndicatorStore.HideIndicator('onChangeLanguage'));
      });
    }
  }

  focus(errors: ErrorResponse, focusForm?: any) {
    if (!errors || !errors.errors) {
      return;
    }
    const keys = Object.keys(errors.errors);
    if (keys && keys.length > 0) {
      for (const key of keys) {
        const e = $('p[field="' + key + '"]')
          .parent()
          .find(
            'input[type="email"],input[type="text"],input[type="password"],input[type="number"],textarea,input[type="file"]'
          ) as JQuery<HTMLElement>;
        if (e.length) {
          if (focusForm && focusForm[key]) {
            focusForm[key].focus();
            focusForm[key].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
            break;
          } else {
            if (e[0].focus) {
              e[0].focus();
            }
            if (e[0].scrollIntoView) {
              e[0].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
            }
            break;
          }
        } else {
          if (focusForm && focusForm[key]) {
            focusForm[key].focus();

            if (focusForm[key].open) {
              focusForm[key].open();
            }
            break;
          }
        }
      }
    }
  }

  // makeFirstKey(key: string, obj: object) {
  //   let firstKey = key;
  //   const keys = Object.keys(this.errors);
  //   if (keys.length > 0) {
  //     if (typeof obj[keys[0]] === 'object') {
  //       firstKey = this.makeFirstKey(keys[0], obj[keys[0]]);
  //     }
  //   }
  //   return firstKey;
  // }

  makeGroupFieldError(acc: any, errors: ValidationErrors, key: string) {
    const firstKey = Object.keys(errors)[0];
    const firstOne = errors[firstKey];
    acc[`${key}${firstKey}`] = new FieldError({
      validator: firstOne,
      value: undefined,
    });
  }

  makeFieldError(errors: ValidationErrors) {
    const firstKey = Object.keys(errors)[0];
    const firstOne = errors[firstKey];
    return new FieldError({
      validator: firstKey,
      value: typeof firstOne === 'object' ? firstOne : undefined,
    });
  }

  makeFormGroupError(formGroup: FormGroup, key: string = '') {
    const errors = {};
    if (formGroup.errors) {
      this.makeGroupFieldError(errors, formGroup.errors, key);
    }
    return Object.keys(formGroup.controls).reduce((acc, cur, i) => {
      const control = formGroup.controls[cur];
      if (control instanceof FormControl) {
        if (control.errors) {
          acc[`${key}${cur}`] = this.makeFieldError(control.errors);
        }
      } else if (control instanceof FormGroup) {
        const fg = this.makeFormGroupError(control, `${cur}.`);
        Object.assign(acc, fg);
        if (control.errors) {
          this.makeGroupFieldError(acc, control.errors, key);
        }
      } else {
        // console.error('---!!! not matched error form group control: ', control);
      }

      return acc;
    }, errors);
  }

  isValid(form: FormGroup, formName: string = 'form', focusForm?: any) {
    form.markAllAsTouched();
    if (!form.valid) {
      // console.log('Object.keys(form.controls) --- ', Object.keys(form.controls), form.value);
      const fieldErrors = this.makeFormGroupError(form);
      this.errors[formName] = new ErrorResponse({
        code: ERROR_TYPE.VALIDATOR.toLowerCase(),
        statusCode: 400,
        type: ERROR_TYPE.VALIDATOR,
        message: 'CLIENT VALIDATOR MESSAGE',
        errors: fieldErrors,
      });
      this.focus(this.errors[formName], focusForm);
      return false;
    }
    return true;
  }

  protected setErrors(errors: ErrorResponse, formName: string = 'form') {
    this.errors[formName] = errors;
    this.focus(errors);
  }

  protected setFieldError(validator: string, fieldName: string, formName: string, value?: any) {
    this.setErrors(
      new ErrorResponse({
        code: ERROR_TYPE.VALIDATOR.toLowerCase(),
        statusCode: 400,
        type: ERROR_TYPE.VALIDATOR,
        message: 'CLIENT VALIDATOR MESSAGE',
        errors: {
          [fieldName]: new FieldError({
            validator,
            value,
          }),
        },
      }),
      formName
    );
  }

  protected withResponseValidator<T>(
    formGroup: FormGroup,
    serverErrorMater: { [key: string]: string[] },
    next: (value: T) => void,
    err?: (error: ErrorResponse) => void
  ): PartialObserver<T> {
    return {
      next,
      error: (error: ErrorResponse) => {
        switch (error.type) {
          case ERROR_TYPE.VALIDATOR:
            Object.keys(error.errors).forEach((field) => {
              // make callback
              const fieldError = error.errors[field] as FieldError;
              const control = formGroup.controls[field];
              control.setErrors(error);
              return fieldError;
            });
            break;
          case ERROR_TYPE.SERVICE:
            if (!serverErrorMater) {
              break;
            }
            Object.keys(formGroup.controls).forEach((k) => {
              if (!serverErrorMater[k]) {
                return;
              }
              if (serverErrorMater[k].includes(error.code)) {
                const control = formGroup.controls[k];
                control.setErrors(error);
              }
            });

            break;
        }
        if (err) {
          err(error);
        }
        formGroup.updateValueAndValidity();
        return;
      },
    };
  }
}
